import React from 'react';
import { useContractsList } from '../../../contextsProperty/ContextContractsList';
import CardsStructure from '../../../components/listView/CardsStructure';
import Card from '../../../../muiComponents/Card';
import DotIcon from '../../../components/DotIcon';
import Status from '../../../../components/Status';
import Tag from '../../../../muiComponents/Tag';
import { formatDate } from '../../../../utils/formatDates';
import {
    IContractListState,
    RATE_SCOPE_MODEL_KEY_ICON,
} from '../../../../types/contracts/contractTypes';
import { RATE_SCOPE_MODEL_KEY_TAG_COLOR } from '../../../../utils/contractUtils/contractUtils';
import { commonIcons } from '../../../../utils/commonVariables/commonIcons';
import { useHistory } from 'react-router-dom';
import encodeBase64 from '../../../../utils/encodeBase64';
import Grid from '../../../../muiComponents/Grid';
import {
    gridSpacing10,
    gridSpacing20,
    singleLG_DoubleSM_ColumnGrid,
} from '../../../../utils/commonVariables/grid';
import GridChild from '../../../../muiComponents/GridChild';
import Tooltip from '../../../../muiComponents/Tooltip';
import Icon from '../../../../muiComponents/Icon';
import routes from '../../../../utils/commonVariables/routes';

interface ContractCardProps {
    item: IContractListState;
}

const ContractCard = ({ item }: ContractCardProps) => {
    const history = useHistory();

    const linkToHotel = routes.propertyDetail(item.IdSupplierHotel);

    const rateScopeIconName =
        RATE_SCOPE_MODEL_KEY_ICON[
            item.RateScopeModelKey as keyof typeof RATE_SCOPE_MODEL_KEY_ICON
        ];

    const rateScopeTagColor =
        RATE_SCOPE_MODEL_KEY_TAG_COLOR[
            item.RateScopeModelKey as keyof typeof RATE_SCOPE_MODEL_KEY_TAG_COLOR
        ];

    const goToDetail = () => {
        const currentPath = history.location.pathname;
        history.push(`${currentPath}/${encodeBase64(item.Id)}`);
    };

    return (
        <Card
            className='padding20 cursor-pointer flex-column gap-10'
            onClick={goToDetail}
        >
            <div className='flex-between flex-align-center gap-10'>
                <h6 className='text-secondary-700 text-size-14'>{item.Name}</h6>
                <div className='flex gap-20 flex-align-center'>
                    <p>
                        {formatDate(item.ActiveFrom)} -{' '}
                        {formatDate(item.ActiveTo)}
                    </p>
                    <DotIcon truthy={item.Enabled} />
                </div>
            </div>
            <div className='flex flex-between gap-10 width100perc border-color-block padding-block-8 border-radius-5'>
                <Status
                    text={item.StaticRateContractStatusType}
                    color={item.StaticRateContractStatusColor}
                />
                <Tag
                    color={rateScopeTagColor}
                    text={item.RateScopeModel}
                    startIcon={rateScopeIconName}
                    className='contract-type__tag'
                />
            </div>

            <Grid columnSpacing={gridSpacing20} rowSpacing={gridSpacing10}>
                {item.IdSupplierHotel ? (
                    <GridChild gridProps={singleLG_DoubleSM_ColumnGrid}>
                        <Tooltip titleText={'hotel'} placement='top-start'>
                            <div className='flex gap-5'>
                                <Icon iconName={commonIcons.HOTEL} />

                                <Tooltip titleText='navigate_to_hotel_detail'>
                                    <p
                                        className=' link-onhover cursor-pointer'
                                        onClick={e => {
                                            e.stopPropagation();
                                            window.open(
                                                linkToHotel,
                                                linkToHotel
                                            );
                                        }}
                                    >
                                        {item.SupplierHotel}
                                    </p>
                                </Tooltip>
                            </div>
                        </Tooltip>
                    </GridChild>
                ) : null}
                {item.IdSupplierHotelRatePlan ? (
                    <GridChild gridProps={singleLG_DoubleSM_ColumnGrid}>
                        <Tooltip titleText={'rate_plan'} placement='top-start'>
                            <div className='flex gap-5'>
                                <Icon iconName={commonIcons.RATE_PLAN} />
                                <p>{item.SupplierHotelRatePlan}</p>
                            </div>
                        </Tooltip>
                    </GridChild>
                ) : null}
            </Grid>
        </Card>
    );
};

const ContractsCards = () => {
    const { items, isLoading, handleScroll } = useContractsList();

    return (
        <CardsStructure
            onScroll={handleScroll}
            items={items}
            isLoading={isLoading}
            cardComponent={props => <ContractCard item={props.item} />}
        />
    );
};

export default ContractsCards;
